import React, { Component } from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import styled from "styled-components";
import { Link } from "react-router-dom";

class ModalQarzRastawxo extends Component {
  render() {
    return (
      <ProductConsumer>
        {(value) => {
          const {
            QR_openmodel,
            QR_CloseModal,
            AddProChange,
            QR_from,
            QR_to,
            QR_hamwqarzakan
          } = value;

          if (!QR_openmodel) {
            return null;
          } else {
            return (
              <ModalContainer>
                <div className="container">
                  <div className="row">
                    <div
                      id="modal"
                      className="col-8 mx-auto col-10 col-lg-7 text-center text-capitalize p-5"
                    >
                      <div className="row">
                        <div className="col-12 mb2">
                          <h3>ڕاپۆرتی ڕاستەوخۆ</h3>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <div className="form-group">
                            <label className="text-danger f3 font-weight-bold">
                              هەتاوەکو
                            </label>
                            <br />
                            <input
                              type="date"
                              onChange={AddProChange}
                              name="QR_to"
                              value={QR_to}
                              className="selectpicker btn btn-dark f4"
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group">
                            <label className="text-danger f3 font-weight-bold">
                              لە
                            </label>
                            <br />
                            <input
                              type="date"
                              onChange={AddProChange}
                              name="QR_from"
                              value={QR_from}
                              className="selectpicker btn btn-dark f4"
                            />
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-6">
                          <Link to="/Product-Raport">
                            <button
                              className="btn btn-danger"
                              onClick={() => QR_CloseModal()}
                            >
                              چوونەدەرەوە
                            </button>
                          </Link>
                        </div>
                        <div className="col-6">
                          <Link to="/Raport-qarzrastawxo">
                            <button
                              className="btn btn-success px-4"
                              onClick={(e) => {
                                QR_hamwqarzakan(e);
                              }}
                            >
                              هەموو قەرزەکان
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalContainer>
            );
          }
        }}
      </ProductConsumer>
    );
  }
}

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  #modal {
    background: #f3e29f;
  }
`;

export default ModalQarzRastawxo;
